import Attorneys from './Attorneys';

export default Attorneys;
